import {
	GridColumnProps,
	GridHeaderCellProps,
} from "@progress/kendo-react-grid";
import CustomDropDownList from "ui/dropDown";
import { getPackagesApi, getProductsApi } from "api/common";
import { ListItemProps } from "@progress/kendo-react-dropdowns";
import React, { FC } from "react";
import {
	CustomGridCommandCell,
	// NumericalHeader,
} from "ui/grid/GridCommandCell";
// import { NumericalCell } from "ui/grid/NumericalCellInput";
import { FooterAggregateSum } from "ui/grid/GridFooters";
import { CLASSNAME, ICON_NAMES } from "utils/constant";
import i18n from "../../../../i18n";
import { NumericalCellAutoFocus } from "ui/grid/NumericalCellInputFocus";
import {
	NumericalHeader,
	NumericalInputHeader,
} from "ui/grid/NumericalCellInput";

let t = i18n.t;

interface StepTwoGridColumnProps {
	addLine: (data: any) => void;
	showError: boolean;
	hasMeetRequirement: (data: any, field: string) => boolean;
	// packages: any[];
	onSelectPackage: (data: any) => void;
	startDeletingLine: (data: any) => void;
	onChange?: (data: any) => void;
	onBlur?: (data: any) => void;
	onFocus?: (data: any) => void;
	onValueChange?: (e: any) => void;
	data: any[];
}

export const stepTwoGridColumns = ({
	showError,
	...prop
}: StepTwoGridColumnProps) => {
	const gridItems: GridColumnProps[] = [
		{
			field: "productId",
			title: t("Product"),
			// editable: true,
			className: `no-border col-min-width`,
			//	width: "350px",
			cells: {
				data: (props) => {
					let code = props.dataItem[props.field as any] || null;
					let display = props.dataItem["product"];
					let value = {} as any;
					if (code !== null) {
						value.id = code;
						value.name = display;
					}
					return (
						<td
							className="no-border col-min-width"
							style={{
								paddingLeft: "1px !important",
							}}
						>
							<CustomDropDownList
								data={[]}
								value={value}
								onSelect={(data) => {
									props.dataItem[props.field as any] = data.id;
									props.dataItem["product"] = data.name;
									props.dataItem["piecesMandatory"] =
										data.isNumberOfUnitsMandatory === true ? 1 : 0;
									prop.addLine(props.dataItem);
								}}
								serverFilterApi={getProductsApi}
								defaultItem={{ code: null, displayName: "Velg Vare" }}
								filterable={true}
								serverFilter={true}
								textField={"name"}
								dataItemKey={"id"}
								showError={
									!prop.hasMeetRequirement(
										props.dataItem,
										props.field as any
									) && showError
								}
								borderColor="none"
							/>
						</td>
					);
				},
			},
		},
		{
			field: "packagingCode",
			title: t("Packaging"),
			className: ` no-border`,
			//	width: "350px",
			editable: true,

			cells: {
				data: (props) => {
					let code = props.dataItem[props.field as any] || null;
					let display = props.dataItem["packaging"];

					let value = {} as any;
					if (code !== null) {
						value.code = code;
						value.name = display;
					}
					return (
						<td className="no-border">
							<CustomDropDownList
								data={[]}
								value={value}
								// onChange={onChange}
								filterable={true}
								serverFilter={true}
								onSelect={(data) => {
									props.dataItem[props.field as any] = data.code;
									props.dataItem["packaging"] = data.name;
									prop.onSelectPackage(props.dataItem);
								}}
								defaultItem={{ code: null, name: t("ChoosePackaging") }}
								textField={"name"}
								dataItemKey={"code"}
								itemRender={itemRender}
								showError={
									!prop.hasMeetRequirement(
										props.dataItem,
										props.field as any
									) && showError
								}
								serverFilterApi={getPackagesApi}
								borderColor="none"
							/>
						</td>
					);
				},
			},
		},
		{
			field: "numberOfPieces",
			title: t("Pieces"),
			editable: true,
			width: "110px",

			cells: {
				data: (props) => (
					<NumericalCellAutoFocus
						{...props}
						{...prop}
						decimalScale={0}
						showError={
							!prop.hasMeetRequirement(props.dataItem, props.field as any) &&
							showError
						}
					/>
				),

				headerCell: (props) => <NumericalInputHeader {...props} />,
			},
			footerCell: (data) => (
				<FooterAggregateSum
					props={data}
					data={prop.data}
					field={"numberOfPieces"}
				/>
			),
			headerClassName: CLASSNAME.TableNumeric,
			className: ` no-border`,
			// headerCell: (props) => <NumericalHeader {...props} />,
		},
		{
			field: "numberOfUnits",
			title: t("Units"),
			editable: true,
			width: "110px",

			cells: {
				data: (props) => (
					<NumericalCellAutoFocus {...props} {...prop} decimalScale={0} />
				),
				headerCell: (props) => <NumericalInputHeader {...props} />,
			},
			footerCell: (data) => (
				<FooterAggregateSum
					props={data}
					data={prop.data}
					field={"numberOfUnits"}
				/>
			),
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
			// headerCell: (props) => <NumericalHeader {...props} />,
		},
		{
			field: "registrationLiveWeightKg",
			title: t("Weight") + " (Kg)",
			editable: true,
			//format: "{0:d}",
			width: "150px",
			cells: {
				data: (props) => (
					<NumericalCellAutoFocus
						{...props}
						{...prop}
						decimalScale={2}
						fixedDecimalScale={true}
						showError={
							!prop.hasMeetRequirement(props.dataItem, props.field as any) &&
							showError
						}
					/>
				),
				headerCell: (props) => <NumericalInputHeader {...props} />,
			},
			footerCell: (data) => (
				<FooterAggregateSum
					props={data}
					data={prop.data}
					decimalScale={2}
					fixedDecimalScale={true}
					field={"registrationLiveWeightKg"}
				/>
			),

			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
			// headerCell: (props) => <NumericalHeader {...props} />,
		},
		{
			field: "price",
			title: t("Price"),
			editable: true,
			width: "150px",
			cells: {
				data: (props) => (
					<NumericalCellAutoFocus
						{...props}
						{...prop}
						decimalScale={2}
						fixedDecimalScale={true}
						showError={
							!prop.hasMeetRequirement(props.dataItem, props.field as any) &&
							showError
						}
					/>
				),
				headerCell: (props) => <NumericalInputHeader {...props} />,
			},

			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} show_error`,
			// headerCell: (props) => <NumericalHeader {...props} />,
		},
		{
			field: "",
			title: "",
			width: "60px",
			cell: (props) => (
				<CustomGridCommandCell
					{...props}
					style={{ display: "flex", justifyContent: "end" }}
					onclick={prop.startDeletingLine}
					iconName={ICON_NAMES.Delete}
				/>
			),
		},
	];

	return gridItems;
};

const itemRender = (
	li: React.ReactElement<HTMLLIElement>,
	itemProps: ListItemProps
) => {
	const itemChildren = [
		<span key={1} style={{ width: "40px" }}>
			&nbsp; {itemProps.dataItem.code}{" "}
		</span>,
		<span key={2}>&nbsp; {itemProps.dataItem.name} </span>,
	];

	return React.cloneElement(li, li.props, itemChildren);
};
// const NumericalHeader: FC<GridHeaderCellProps> = (props) => {
// 	return <span>{props.title}</span>;
// };
